import styles from './PipRow.module.css'

interface PipRowProps {
  total: number
  used: number
}

export default function PipRow({ total, used }: PipRowProps) {
  return (
    <div className={styles.row}>
      {Array.from({ length: total }).map((_, i) => (
        <span key={i} className={[styles.pip, i < used && styles.used].filter(Boolean).join(' ')} />
      ))}
    </div>
  )
}
